import About from "./About";
import Projects from "./Projects";
import Hero from "./Hero";
import Contact from "./Contact";
import Footer from "./Footer";
export default function MainLayout() {
  return (
    <div className="relative min-h-screen bg-[#020617] text-white overflow-hidden">
      <div className="absolute inset-0 bg-grid-pattern pointer-events-none"></div>
      <div className="absolute top-0 left-1/4 w-[500px] h-[500px] bg-cyan-600/20 rounded-full blur-[120px] pointer-events-none"></div>
      <div className="absolute bottom-1/4 right-1/4 w-[600px] h-[600px] bg-blue-800/10 rounded-full blur-[150px] pointer-events-none"></div>
      <main className="relative z-10 container mx-auto px-6 py-20">
        <Hero />
        <About />
        <Projects />
        <Contact />
        <Footer />
      </main>
    </div>
  );
}